import { render, staticRenderFns } from "./PassportFront.vue?vue&type=template&id=185bfa34&scoped=true"
var script = {}
import style0 from "./PassportFront.vue?vue&type=style&index=0&id=185bfa34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185bfa34",
  null
  
)

export default component.exports